const createImageOrLinkedImage = ({
  imageUrl,
  altText,
  linkUrl,
  linkLabel,
  openInNewTab = true
}) => {
  const image = document.createElement("img");
  image.src = imageUrl;
  image.alt = altText;
  if (linkUrl) {
    const link = document.createElement("a");
    link.setAttribute("href", linkUrl);
    if (openInNewTab) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    }
    if (linkLabel) {
      link.setAttribute("aria-label", linkLabel);
    }
    link.appendChild(image);
    return link;
  }
  return image;
};
export {
  createImageOrLinkedImage
};
//# sourceMappingURL=createImageOrLinkedImage.js.map
